
import { createContext, useContext } from 'react'

const defaultValue = {
  activeTabRoutePath: '',
  refreshTab: () => { },
  closeTab: () => { },
  closeOtherTab: () => { },
}


export const KeepAliveTabContext = createContext(defaultValue);

export const useKeepAliveContext = () => {
    return useContext(KeepAliveTabContext);
}
